type ScheduleTimer = (callback: () => void, delayMs: number) => unknown
type ClearTimer = (handle: unknown) => void

const defaultSchedule: ScheduleTimer = (callback, delayMs) =>
  globalThis.setTimeout(callback, delayMs)

const defaultClear: ClearTimer = (handle) =>
  globalThis.clearTimeout(handle as ReturnType<typeof setTimeout>)

/** Owns one pending debounced action and makes explicit/manual cancellation synchronous. */
export class DebouncedAction {
  private timer: unknown = null

  constructor(
    private readonly scheduleTimer: ScheduleTimer = defaultSchedule,
    private readonly clearTimer: ClearTimer = defaultClear,
  ) {}

  schedule(action: () => void, delayMs: number): void {
    this.cancel()
    this.timer = this.scheduleTimer(() => {
      this.timer = null
      action()
    }, delayMs)
  }

  cancel(): void {
    if (this.timer === null) return
    this.clearTimer(this.timer)
    this.timer = null
  }
}
